import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { useAppSelector } from "../store";

interface ITradeSlice {
  selectedTab: "swap" | "targets" | "scheduled";
}

const initialState: ITradeSlice = {
  selectedTab: "swap",
};

export const TradeSlice = createSlice({
  name: "trade",
  initialState,
  reducers: {
    setTradeTab: (state, action: PayloadAction<"swap" | "targets" | "scheduled">) => {
      state.selectedTab = action.payload;
    },
  },
});

export const { setTradeTab } = TradeSlice.actions;

export const useTradeSlice = () => useAppSelector((state): ITradeSlice => state.trade);
